import { styled } from "@mui/material/styles";
import Checkbox from '@mui/material/Checkbox';
export default styled(Checkbox)(({ theme, ownerState }) => {
  const { palette } = theme;
  const { color } = ownerState;
  return {
    color: palette[color].main,
    '&.Mui-checked': {
        color: palette[color].main+'60',
      },
      '&.MuiFormControlLabel-label':{
          color:'red important'
      }
  };
});
